import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../Modal';
import styles from '../../login/LoginForm/LoginForm.module.css';
import registerPriceFlow from '../hook';

const RegisterPricingForm = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalText, setModalText] = useState('');
  const [data, setData] = useState({
    paywallprice: '',
    tipjarpricelow: '',
    tipjarpricemedium: '',
    tipjarpricehigh: '',
    role: 'admin',
  });

  const handleModalText = (text) => {
    setModalText(text);
  };

  const updatePriceSettings = registerPriceFlow();

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowModal(true);

    const paywallPrice = data.paywallprice;
    const tipJarPriceLow = data.tipjarpricelow;
    const tipJarPriceMedium = data.tipjarpricemedium;
    const tipJarPriceHigh = data.tipjarpricehigh;

    updatePriceSettings({
      paywallPrice,
      tipJarPriceLow,
      tipJarPriceMedium,
      tipJarPriceHigh,
      changeModalText: handleModalText,
      setShowModal,
    });
  };

  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <form id={styles['login-form']} onSubmit={handleSubmit}>
      <p>Paywall Price</p>
      <input
        required
        type="text"
        name="paywallprice"
        onChange={handleChange}
        value={data.paywallprice}
        placeholder="Paywall Price"
        className={styles['login-form__input']}
      />
      <h5>TipJar Price</h5>
      <input
        required
        type="text"
        name="tipjarpricelow"
        onChange={handleChange}
        value={data.tipjarpricelow}
        placeholder="Low"
        className={styles['login-form__input']}
      />
      <input
        required
        type="text"
        name="tipjarpricemedium"
        onChange={handleChange}
        value={data.tipjarpricemedium}
        placeholder="Medium"
        className={styles['login-form__input']}
      />
      <input
        required
        type="text"
        name="tipjarpricehigh"
        onChange={handleChange}
        value={data.tipjarpricehigh}
        placeholder="High"
        className={styles['login-form__input']}
      />
      <input
        type="submit"
        value="Update"
        disabled={
          data.paywallprice === '' ||
          data.tipjarpricelow === '' ||
          data.tipjarpricemedium === '' ||
          data.tipjarpricehigh === ''
        }
        id={styles['login-form__submit']}
      />
      {showModal && (
        <RegisterModal setShowModal={setShowModal} text={modalText} />
      )}
    </form>
  );
};

const RegisterModal = ({ setShowModal, text }) => (
  <Modal setShowModal={setShowModal} isLogin>
    <p>{text}</p>
  </Modal>
);

RegisterModal.propTypes = {
  setShowModal: PropTypes.node.isRequired,
  text: PropTypes.node.isRequired,
};

export default RegisterPricingForm;
